export const getPasteTransformers = () => {
    return {
        transformPastedText: (text: string) => {
            return text.replace(/\xA0/g, " ");
        },
        transformPastedHTML: (html: string) => {
            const isFromTiptap = /data-pm-slice="\d \d \[\]"/.test(html);
            let result = "";

            // remove base64 images
            result = html.replace(/<img[^>]*src="data:image\/[^"]*"[^>]*>/gi, "");

            if (!isFromTiptap) {
                // remove background-color, color
                result = result.replace(
                    /(background-color|color): ?(rgba?\(\s*\d+,\s*\d+,\s*\d+(,\s*\d+(?:\.\d+)?)?\)|hsla?\(\s*\d+,\s*\d+%,\s*\d+%(,\s*\d+(?:\.\d+)?)?\)|#[0-9a-fA-F]{3,6}|(aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|purple|red|silver|teal|white|yellow)\b);?/gi,
                    ""
                );
            }

            // remove font size
            result = result.replace(/font-size:\s*\d+(?:\.\d+)?(?:px|pt|em|rem|%);?/gi, "");
            result = result.replace(/<font[^>]*size="[^"]*"[^>]*>/gi, "");
            result = result.replace(/<\/font>/gi, "");

            return result;
        },
    };
};

export const getFlashcardPasteTransformers = () => {
    return {
        transformPastedText: (text: string) => {
            return text.replace(/\xA0/g, " ");
        },
        transformPastedHTML: (html: string) => {
            const isFromTiptap = /data-pm-slice="\d \d \[\]"/.test(html);
            let result = "";

            // remove base64 images
            result = html.replace(/<img[^>]*src="data:image\/[^"]*"[^>]*>/gi, "");

            if (!isFromTiptap) {
                result = result.replace(
                    /(background-color|color): ?(rgba?\(\s*\d+,\s*\d+,\s*\d+(,\s*\d+(?:\.\d+)?)?\)|hsla?\(\s*\d+,\s*\d+%,\s*\d+%(,\s*\d+(?:\.\d+)?)?\)|#[0-9a-fA-F]{3,6}|(aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|purple|red|silver|teal|white|yellow)\b);?/gi,
                    ""
                );
            }

            // replace heading tags
            result = result.replace(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/gi, "$1");

            result = result.replace(/font-family:[^;}"']+;?/gi, "");
            result = result.replace(/font-size:\s*\d+(?:\.\d+)?(?:px|pt|em|rem|%);?/gi, "");
            result = result.replace(/<font[^>]*size="[^"]*"[^>]*>/gi, "");
            result = result.replace(/<\/font>/gi, "");

            // replace links
            result = result.replace(/<a[^>]*>(.*?)<\/a>/gi, "$1");

            return result;
        },
    };
};
